module.exports = __webpack_public_path__ + "static/media/home-slider-1.c4388bfe.jpg";